import { IAddress } from '../address/address';
import { EntityReference, IPhotoEntityReference } from '../basic';
import { IOpeningTimeInfo } from '../company-info/company-info';
import { IContact } from '../contact/contact';

/** Type of chainstore location */
export enum ChainstoreType {
  /** Filiale */
  ChainStore = 0,
  /** Zentrale */
  Headquarter = 1,
  /** Lager */
  Warehouse = 2,
  /** Halle */
  Hall = 3,
  /** Ort */
  Place = 4
}

/**
 * Main interface for chainstore data used across the app
 */
export interface IChainstore {
  /** Unique identifier of the chainstore */
  chainstoreId: number;
  /** Primary display name of the chainstore (e.g. "Store Munich-North") */
  name: string;
  /** Secondary name (optional subtitle or alternative label) */
  name2?: string;
  /** Priority used for sorting chainstore lists (higher value = higher precedence) */
  priority: number;
  /** Long description of the chainstore */
  description?: string;
  /** Short sub-description shown below the main description */
  subDescription?: string;
  /** Distance in kilometers from the current reference point (only set in geo-based queries) */
  distance?: number;
  /** Physical address of the chainstore */
  address?: IAddress;
  /** Primary contact person/details for the chainstore */
  contact?: IContact;
  /** Reference to the owning member/tenant */
  member?: EntityReference;
  /** Reference to the CMS page associated with this chainstore */
  page?: EntityReference;
  /** Gallery photos of the chainstore — the first entry is treated as the main image */
  photos?: IPhotoEntityReference[];
  /** Tag references used for filtering/categorization */
  tags?: EntityReference[];
  /** Phone number of the chainstore */
  phone: string;
  /** Email address of the chainstore */
  eMailAddress: string;
  /** Website URL of the chainstore */
  webSite?: string;
  /** Fax number of the chainstore */
  fax?: string;
  /** Whether this chainstore supports Click & Collect pickup */
  canClickAndCollect?: boolean;
  /** Type of the chainstore (e.g. regular store, headquarter, warehouse) */
  type?: ChainstoreType;
  /** Facebook URL */
  facebookUrl?: string;
  /** Twitter URL */
  twitterUrl?: string;
  /** Xing URL */
  xingUrl?: string;
  /** Instagram URL */
  instagramUrl?: string;
  /** Google Plus URL */
  googlePlusUrl?: string;
  /** Pinterest URL */
  pinterestUrl?: string;
  /** YouTube URL */
  youtubeUrl?: string;
  /** IANA-style timezone identifier of the chainstore (e.g. "W. Europe Standard Time"), used to format opening times */
  timeZone?: string;

  // Opening times
  /** Regular opening times (Mon-Fri, Sat, Sun) */
  openingTimesInfos: IOpeningTimeInfo[];
  /** Additional info on opening times (e.g. "Lunch break: 12:30 to 13:30") - one entry per location */
  openingTimesInfo: string;
  /** Free text for special opening times (e.g. "Closed between Christmas and New Year") */
  additionalOpeningTimes: string;
  /** Special opening times (seasonal, holidays, etc.) - take precedence over OpeningTimesInfos */
  specialOpeningTimesInfo: IOpeningTimeInfo[];
}
